var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPartialStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82843 1.33294C11.3274 1.33294 14.0932 4.51866 13.3801 8.13758C12.9469 10.3436 11.1674 12.1231 8.96809 12.5496C5.34916 13.2627 2.16344 10.4969 2.16344 6.99792C2.16344 3.87218 4.70269 1.33294 7.82843 1.33294ZM7.82843 0C3.70299 0 0.410633 3.57227 0.87716 7.79768C1.23039 10.9967 3.83628 13.6026 7.03533 13.9558C11.2541 14.4224 14.833 11.13 14.833 7.00458C14.8263 3.1324 11.6939 0 7.82843 0Z",
    fill: "#FD8B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18385 2.97461H7.48381C7.2905 2.97461 7.13379 3.09998 7.13379 3.25462V8.2949C7.13379 8.44955 7.2905 8.57491 7.48381 8.57491H8.18385C8.37716 8.57491 8.53387 8.44955 8.53387 8.2949V3.25462C8.53387 3.09998 8.37716 2.97461 8.18385 2.97461Z",
    fill: "#FD8B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16705 9.49414H7.50034C7.31624 9.49414 7.16699 9.64339 7.16699 9.82749V10.4942C7.16699 10.6783 7.31624 10.8275 7.50034 10.8275H8.16705C8.35115 10.8275 8.5004 10.6783 8.5004 10.4942V9.82749C8.5004 9.64339 8.35115 9.49414 8.16705 9.49414Z",
    fill: "#FD8B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPartialStock);
export default __webpack_public_path__ + "static/media/FBOPartialStock.bcc1ea771ee21c545a85a13b20e0df06.svg";
export { ForwardRef as ReactComponent };